// extracted by mini-css-extract-plugin
module.exports = {"video":"Video_video__1ozO2","iframeVid":"Video_iframeVid__2hoST"};